<template>
  <div>
    <header class="d-sm-flex justify-content-between align-items-center">
      <h1>Empleados</h1>
      <b-button :to="{name: 'EmployeeNew'}" variant="outline-primary">Nuevo Empleado</b-button>
    </header>
    <hr>
    <template v-if="isGetEmployeesLoading">
      <div class="text-center">
        <p class="lead">Loading...</p>
        <b-spinner variant="primary" label="Spinning"></b-spinner>
      </div>
    </template>
    <template v-else>
      <template v-if="isEmployeesListEmpty">
        <p class="lead">De momento no hay empleados...</p>
      </template>
      <template v-else>
        <b-table
          striped
          borderless
          hover
          sort-by="createdAt"
          :sort-desc="true"
          :items="employeesFormatted"
          :fields="tableFields"
          responsive="sm"
          @row-clicked="rowClicked">
          <template slot="status" slot-scope="data">
            <b-badge :variant="data.item.statusClass">{{ data.value }}</b-badge>
          </template>
        </b-table>
      </template>
    </template>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { dateMixin } from '@/mixins/dateMixin'

export default {
  name: 'Employees',
  mixins: [dateMixin],
  created () {
    this.loadEmployees()
  },
  data () {
    return {
      isGetEmployeesLoading: true,
      isEmployeesListEmpty: null,
      employees: [],
      tableFields: [
        {
          key: 'name',
          label: 'Nombre',
          sortable: true
        },
        {
          key: 'surname',
          label: 'Apellidos',
          sortable: true
        },
        {
          key: 'phone',
          label: 'Telf.'
        },
        {
          key: 'status',
          label: 'Estado',
          sortable: true
        },
        {
          key: 'createdAt',
          label: 'F. creación',
          sortable: true
        }
      ]
    }
  },
  computed: {
    employeesFormatted () {
      return this.employees.map(i => {
        i.createdAt = this.dateDDMMYYYY(i.createdAt)
        i.status = i.isActive ? 'Activo' : 'Inactivo'
        i.statusClass = this.setStatusVariant(i.isActive)
        return i
      })
    }
  },
  methods: {
    ...mapActions([
      'getEmployees'
    ]),
    loadEmployees () {
      this.getEmployees()
        .then((res) => {
          this.isGetEmployeesLoading = false
          if (res.empty) {
            this.isEmployeesListEmpty = true
            return false
          }
          res.forEach(doc => {
            this.employees.push({ id: doc.id, ...doc.data() })
          })
        })
        .catch((err) => {
          console.debug('getEmployees')
          console.log(err)
        })
    },
    rowClicked (item, index, ev) {
      this.$router.push({ name: 'EmployeeDetail', params: { employeeId: item.id } })
    },
    setStatusVariant (val) {
      return val === true ? 'primary' : 'secondary'
    }
  }
}
</script>
